import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button } from 'antd';
import clx from 'classnames';
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Dropdown } from '../dropdown/Dropdown';

export interface ISkipLink {
  label?: string;
  htmlId: string;
}
// TODO: check whether to delete?
// const fixturesLinks: ISkipLink[] = [
//   { label: 'Vai al menu scelta lingua', htmlId: 'lang-menu' },
//   { label: 'Vai al contenuto principale', htmlId: 'main' },
//   { label: 'Vai al footer della pagina', htmlId: 'footer' },
// ];

const SkipLinkButton = styled(Button)`
  transition: left 0s ease-in-out;
  left: -1000px;
  &.menu-open {
    left: 8px;
    top: 8px;
  }
`;
const SkipLinkWrapper = styled.div`
  z-index: 9000;
  position: absolute;
  top: 0;
  left: 0;
  width: 0px;
  &:focus,
  &:hover,
  &:active,
  &:focus-within {
    ${SkipLinkButton} {
      left: 8px;
      top: 8px;
    }
  }
  .skip-link-a {
    width: 100%;
    display: block;
  }
`;

export interface ISkipLinksProps {
  links?: ISkipLink[];
}

/**
 * Componente di visualizzazione dei Skip Links per la navigazione da tastiera
 */
export function SkipLinks(props: ISkipLinksProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();

  if (!props?.links) return null;

  const handleMenuClick = (e: any) => {
    // console.log('click htmlID', e, e.key);
    setMenuOpen(false);
    return false;
  };

  const items = props?.links.map(link => ({
    key: link.htmlId,
    label: (
      <a href={`#${link.htmlId}`} className="skip-link-a">
        {link.label}
      </a>
    ),
  }));

  return (
    <SkipLinkWrapper>
      <Dropdown
        menu={{
          items,
          onClick: handleMenuClick,
        }}
        trigger={['click']}
        open={menuOpen}
        onOpenChange={open => setMenuOpen(open)}
        autoFocus
      >
        <SkipLinkButton
          onClick={e => e.preventDefault()}
          className={clx({ 'menu-open': menuOpen })}
          tabIndex={0}
          size="large"
        >
          {t(
            'skip-links.open-menu',
            'Apri il menu di navigazione Skip Link',
          )}
          <DownOutlined aria-hidden />
        </SkipLinkButton>
      </Dropdown>
    </SkipLinkWrapper>
  );
}
